import { __rest } from "tslib";
import * as React from 'react';
const ChevronDownLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", fill: "currentColor", width: size || "32", height: size || "32" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M25.2974247,11 L26.0045315,11.7071068 L16.711,20.999 L16.7136452,21.0017696 L16.0065384,21.7088764 L16.004,21.706 L16.0032116,21.707748 L15.2961048,21.0006412 L15.297,20.999 L6,11.7071068 L6.70710678,11 L16.004,20.292 L25.2974247,11 Z" })));
};
ChevronDownLarge.displayName = 'ChevronDownLarge';
export default ChevronDownLarge;
//# sourceMappingURL=ChevronDownLarge.js.map